// extracted by mini-css-extract-plugin
export default {"error":"error-label_error__DML3m"};